import colors from '../colors';
import svg from '../shapes';
export var base = 8;
export var baseColors = 8;
export var size = 24;
export var total = Math.pow(base, 3) * Math.pow(baseColors, 3);
export var id = 0;

function ri(total) {
  return Math.floor(Math.random() * total);
}

export function random() {
  // return `${ri(base)}${ri(baseColors)}${ri(base)}${ri(baseColors)}${ri(base)}${ri(baseColors)}`
  return Math.floor(Math.random() * total + total).toString(base).substring(1);
}
export function outer(id, width) {
  return "<svg ".concat(width ? "width=\"".concat(width, "\" height=\"").concat(width, "\" ") : '', "viewBox=\"0 0 ").concat(size, " ").concat(size, "\" xmlns=\"http://www.w3.org/2000/svg\">") + inner(id) + "</svg>";
}
export function inner(value) {
  var clipA = "clip-a-".concat(id);
  var clipB = "clip-b-".concat(id);
  var urlA = "url(#".concat(clipA, ")");
  var urlB = "url(#".concat(clipB, ")");
  var half = size / 2;
  ++id;
  return "<defs><clipPath id=\"".concat(clipA, "\"><rect width=\"").concat(half + 1, "\" height=\"").concat(size, "\" x=\"0\" y=\"0\"></rect></clipPath>") + "<clipPath id=\"".concat(clipB, "\"><rect width=\"").concat(half, "\" height=\"").concat(size, "\" x=\"").concat(half, "\" y=\"0\"></rect></clipPath></defs>") + "<g style=\"fill: ".concat(colors.bg[value[1]][0], "\" clip-path=\"").concat(urlA, "\">").concat(svg.body[value[0]], "</g>") + "<g style=\"fill: ".concat(colors.bg[value[1]][1], "\" clip-path=\"").concat(urlB, "\">").concat(svg.body[value[0]], "</g>") + "<g style=\"fill: ".concat(colors.fg[value[1]][value[3]][0], "\" clip-path=\"").concat(urlA, "\">").concat(svg.eyes[value[2]], "</g>") + "<g style=\"fill: ".concat(colors.fg[value[1]][value[3]][1], "\" clip-path=\"").concat(urlB, "\">").concat(svg.eyes[value[2]], "</g>") + "<g style=\"fill: ".concat(colors.fg[value[1]][value[5]][0], "\" clip-path=\"").concat(urlA, "\">").concat(svg.mouth[value[4]], "</g>") + "<g style=\"fill: ".concat(colors.fg[value[1]][value[5]][1], "\" clip-path=\"").concat(urlB, "\">").concat(svg.mouth[value[4]], "</g>");
}